// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const relicanth: PokeData = {
  "id": 369,
  "name": "relicanth",
  "height": 10,
  "weight": 234,
  "base_experience": 170,
  "types": [
    PokeType.WATER,
    PokeType.ROCK
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "water-gun",
    "hydro-pump",
    "harden",
    "rest",
    "flail",
    "ancient-power",
    "yawn",
    "dive",
    "mud-sport",
    "rock-tomb",
    "aqua-tail",
    "head-smash"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "ancient-power",
    "rock-tomb",
    "aqua-tail",
    "life-dew",
    "stone-crush",
    "bubble-beam",
    "stealth-rock",
    "rain-dance",
    "power-siphon",
    "liquidation",
    "brine"
  ],
  "evolution_chain": {
    "id": 189,
    "item": null,
    "species": [
      {
        "name": "relicanth",
        "order": 399,
        "types": [
          PokeType.WATER,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 162,
    "speed": 90,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
